import { useState, useRef, useEffect } from "react";
import "../../_css/SearchableDropdown.css";

export default function MultiSelectDropdown({
  options = [],
  selected = [],
  setSelected,
  placeholder = "Select...",
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filteredOptions = options?.filter((opt) => {
    if (typeof opt === "string") {
      return opt?.toLowerCase()?.includes(search?.toLowerCase());
    }
    return false;
  }) || [];

  const handleToggle = (option) => {
    if (disabled) return;
    if (selected.includes(option)) {
      setSelected(selected.filter((item) => item !== option));
    } else {
      setSelected([...selected, option]);
    }
  };

  const handleRemove = (option, e) => {
    e.stopPropagation();
    if (disabled) return;
    setSelected(selected.filter((item) => item !== option));
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayText =
    selected.length > 0
      ? selected.length === 1
        ? selected[0]
        : `${selected.length} selected`
      : placeholder;

  return (
    <div className="s-dropdown" ref={dropdownRef} style={{ width: "100%" }}>
      <div
        className="s-dropdown-header"
        style={{ backgroundColor: disabled ? "#f3f4f6" : "#FFFFFF" }}
        onClick={() => !disabled && setOpen(!open)}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px",
            alignItems: "center",
            minHeight: "24px",
            width: "90%",
          }}
        >
          {selected.length > 0 && selected.length <= 2 ? (
            selected.map((item, idx) => (
              <span
                key={idx}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "2px 8px",
                  backgroundColor: "#E0F5FE",
                  color: "#01A7DE",
                  borderRadius: "4px",
                  fontSize: "12px",
                }}
              >
                {item}
                {!disabled && (
                  <span
                    onClick={(e) => handleRemove(item, e)}
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    ×
                  </span>
                )}
              </span>
            ))
          ) : (
            <span style={{ color: selected.length > 0 ? "#030712" : "#9CA3AF" }}>
              {displayText}
            </span>
          )}
        </div>
        <span
          className="s-arrow"
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) {
              setOpen(!open);
            }
          }}
        >
          {open ? "▲" : "▼"}
        </span>
      </div>

      {open && !disabled && (
        <div className="s-dropdown-menu" style={{ maxHeight: "200px" }}>
          <div style={{ padding: "8px" }}>
            <input
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                width: "100%",
                padding: "6px 8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                fontSize: "14px",
                outline: "none",
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <ul style={{ maxHeight: "150px", overflowY: "auto" }}>
            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt, idx) => (
                <li
                  key={idx}
                  onClick={() => handleToggle(opt)}
                  style={{
                    backgroundColor: selected.includes(opt) ? "#E0F5FE" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selected.includes(opt)}
                    onChange={() => handleToggle(opt)}
                    style={{ cursor: "pointer" }}
                  />
                  {opt}
                </li>
              ))
            ) : (
              <li style={{ color: "#9CA3AF", fontStyle: "italic" }}>
                No options found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}

